import React, { useState } from "react";
import useComponents from "~/hooks/useAllComponents";
import cx from "@caesars-ui/core/dist/utils/cx";
import Row from "./components/ComponentListRow";
import { Badge, TextField } from "@caesars-ui/core";

const HeaderCol = ({ children }) => {
  return (
    <div
      className={cx(
        {
          "text-center": children !== "Name",
        },
        "border-b-1 border-solid border-fg-default py-4 heading-md-bold text-fg-default"
      )}
    >
      {children}
    </div>
  );
};

const ComponentListHeader = () => {
  return (
    <>
      <HeaderCol>Name</HeaderCol>
      <HeaderCol>Figma Library</HeaderCol>
      <HeaderCol>Documentation</HeaderCol>
      <HeaderCol>Web</HeaderCol>
      <HeaderCol>iOS</HeaderCol>
    </>
  );
};

const StatusLegend = () => {
  return (
    <div className="mb-10">
      <h4>Status Legend</h4>
      <div className="grid grid-cols-[auto,1fr,auto,1fr] items-center gap-4">
        <span>--</span>
        <div>Unplanned, no status yet.</div>
        <Badge status="info" text="Planned" size="sm" />
        <div>Planning stage complete.</div>
        <Badge type="minimal" text="Not Planned" size="sm" />
        <div>No plans to work on component.</div>
        <Badge status="positive" text="Ready" size="sm" />
        <div>Published and ready for use.</div>
        <Badge type="subtle" text="Partially Ready" size="sm" />
        <div>Published and working but missing features.</div>
        <Badge status="accent" text="In Progress" size="sm" />
        <div>Development and design work being done.</div>

        <Badge status="negative" text="Deprecated" size="sm" />
        <div>Published, but not recommended for use (tech debt artifact).</div>
      </div>
    </div>
  );
};

const ComponentList = () => {
  const components = useComponents()
    .allAirtableComponents.edges.map((e) => e.node.data)
    .filter((d) => d.Type === "Component")
    .sort((a, b) => (a.Name < b.Name ? -1 : 1));
  const [filterTextValue, setFilterTextValue] = useState("");
  const handleFilterChange = (e) => {
    setFilterTextValue(e.target.value);
  };

  const filteredComponents = components.filter((c) =>
    filterTextValue
      ? c.Name.toLowerCase().includes(filterTextValue.toLowerCase())
      : true
  );

  return (
    <div>
      <StatusLegend />
      <div className="mt-20">
        <TextField
          label="Filter Components"
          value={filterTextValue}
          onChange={handleFilterChange}
          className="min-w-[300px]"
        />
      </div>
      <div className="grid grid-cols-[300px_1fr_1fr_1fr_1fr]">
        <ComponentListHeader />
        {filteredComponents.length ? (
          filteredComponents.map((c, i) => (
            <Row data={c} key={`${c.Slug}-${i}`} />
          ))
        ) : (
          <div className="text-fg-moderate body-md">
            No matches, please adjust your filter text.
          </div>
        )}
      </div>
    </div>
  );
};

export default ComponentList;
